import { ToolsStatusTypes } from './types';

export const toolsStatus = () => ({
  types: [
    ToolsStatusTypes.GET_TOOLS_STATUS_REQUEST,
    ToolsStatusTypes.GET_TOOLS_STATUS_SUCCESS,
    ToolsStatusTypes.GET_TOOLS_STATUS_FAILURE,
  ],
  promise: (client: any) => client.get('/tools_status.json'),
});

export const createIncident = (cache_name: any, status: any, description: any, expire_in: any) => ({
  types: [
    ToolsStatusTypes.CREATE_INCIDENT_REQUEST,
    ToolsStatusTypes.CREATE_INCIDENT_SUCCESS,
    ToolsStatusTypes.CREATE_INCIDENT_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/tools_status.json', {
      cache_name,
      status,
      description,
      expire_in,
    }),
});

export const deleteIncidentCache = (cache_name: string) => ({
  types: [
    ToolsStatusTypes.DELETE_INCIDENT_REQUEST,
    ToolsStatusTypes.DELETE_INCIDENT_SUCCESS,
    ToolsStatusTypes.DELETE_INCIDENT_FAILURE,
  ],
  promise: (client: any) => client.delete(`/tools_status/${cache_name}`),
});
